<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th></th>
							<th v-for="(item, idx) in graphList" :key="idx">{{ item.mesDd }}</th>
							<!-- 합계 -->
							<th class="px-0">{{ getMessage_('QWCC001425') }}</th>
						</tr>
						<tr>
							<!-- 적합 -->
							<th class="px-0">{{ getMessage_('QWCC001671') }}</th>
							<td v-for="(item, idx) in graphList" :key="idx">
								{{ item.okCnt }}
							</td>
							<td>{{ getOkSum }}</td>
						</tr>
						<tr>
							<!-- 부적합 -->
							<th class="px-0">{{ getMessage_('QWCC001672') }}</th>
							<td v-for="(item, idx) in graphList" :key="idx">
								{{ item.ngCnt }}
							</td>
							<td>{{ getNgSum }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	methods: {
		...rootMethods,
		...serviceMethods
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		getOkSum() {
			let cnt = 0;
			for (const item of this.graphList) {
				cnt += Number(item.okCnt);
			}
			return cnt;
		},
		getNgSum() {
			let cnt = 0;
			for (const item of this.graphList) {
				cnt += Number(item.ngCnt);
			}
			return cnt;
		}
	}
};
</script>

<style lang="scss" scoped></style>
